export const NAVIGATION_PANEL_QUICK_START_GUIDE_LOCALSTORAGE = 'NAVIGATION_PANEL_QUICK_START_GUIDE_LOCALSTORAGE';
